import React from "react";
import { tw } from "@careinfo/tailwind";

function Info() {
  return <div></div>;
}

export default Info;
